import { useTranslation } from "react-i18next";
import { Box, Checkbox, IconButton, ListItemText, MenuItem, Select } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useCallback } from "react";
import { setLocalStorageValue } from "../../../../common/helpers";
import { TaskEnums, TaskEnumsLists } from "../../../../common/constants";
import { FilterListOff as ClearIcon } from "@mui/icons-material";


const useStyles = makeStyles()(
  (theme) => ({
    root: {
      padding: theme.spacing(1.5),
      paddingBottom: theme.spacing(1),
      paddingTop: 0,
      borderBottom: `1px solid ${theme.palette.divider}`,
      marginTop: theme.spacing(-1),
      marginLeft: theme.spacing(-2),
      marginRight: theme.spacing(-2),
      marginBottom: theme.spacing(1.5),
      display: "flex",
      justifyContent: "flex-start",
      gap: theme.spacing(1.5)
    },
    select: {
      background: theme.palette.neutral.main,
      border: "none !important",
      outline: "none !important",
      height: "40px",
      maxWidth: "50vw",
      borderRadius: theme.spacing(2.5),
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
    }
  })
);

export default function DispatchToolbar(props) {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { orderTasksBy, setOrderTasksBy, filterTasksBy, setFilterTasksBy } = props;

  const onSetOrderTasksBy = useCallback((ev) => { setOrderTasksBy(ev.target.value); setLocalStorageValue("orderTasksBy", ev.target.value) }, []);
  const onSetTaskFilterBy = useCallback((ev) => {
    const v = ev.target.value.includes("") ? [] : ev.target.value;
    setFilterTasksBy(v);
    setLocalStorageValue("filterTasksByMultiple", JSON.stringify(v));
  }, []);

  const renderFilterValue = useCallback((selected) => {
    return selected.length === 0 ? t("common:all") : selected.map(value => t(`task:enums:state:${TaskEnumsLists.State[value]}`)).join(", ");
  }, [t]);

  return (
    <Box className={classes.root}>

      <Select size="small" variant="outlined" value={orderTasksBy} onChange={onSetOrderTasksBy} className={classes.select}>
        <MenuItem value="new">{t("common:filters:orderBy:new")}</MenuItem>
        <MenuItem value="old">{t("common:filters:orderBy:old")}</MenuItem>
        <MenuItem value="state_asc">{t("common:filters:orderBy:state_asc")}</MenuItem>
        <MenuItem value="state_desc">{t("common:filters:orderBy:state_desc")}</MenuItem>
        <MenuItem value="driver">{t("common:filters:orderBy:driver")}</MenuItem>
        <MenuItem value="eta">{t("common:filters:orderBy:eta")}</MenuItem>
      </Select>

      <Select
        size="small"
        variant="outlined"
        value={filterTasksBy}
        onChange={onSetTaskFilterBy}
        className={classes.select}
        multiple
        renderValue={renderFilterValue}
        displayEmpty
      >
        <MenuItem value="">
          <IconButton>
            <ClearIcon />
          </IconButton>
          <ListItemText primary={t("common:all")} />
        </MenuItem>

        {TaskEnumsLists.State.filter((_, state) => state < TaskEnums.State.Completed).map((state, value) => (

          <MenuItem value={value} key={value}>
            <Checkbox checked={filterTasksBy.includes(value)} />
            <ListItemText primary={t(`task:enums:state:${state}`)} />
          </MenuItem>

        ))}
      </Select>

    </Box>
  );
}
